/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { AuthNumberBusinessService } from '../../resources/auth-number-business.service';
import { AuthNumberRequestDialogComponent } from './auth-number-request-dialog.component';

export const authNumberRequestDialogRoute = createDialogRoute({
  component: AuthNumberRequestDialogComponent,
  init: AuthNumberBusinessService,
});
